// import React from 'react';
// import { Box, Grid, Typography, Button,useMediaQuery } from '@mui/material';
// import { Link } from 'react-router-dom';
// import { ArrowForward } from '@mui/icons-material';
// import { useTheme } from "@mui/material/styles";

// const Partner = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.down("md"));

//   // Strategic Alliances configuration
//   const allianceLogoHeight = isMobile ? 150 : isTablet ? 200 : 300;
//   const allianceRepeatCount = 12;
//   const allianceTotalImages = 2 * allianceRepeatCount;
//   const allianceScrollAmount = allianceLogoHeight * allianceTotalImages;

//   // Associations configuration  
//   const associationLogoHeight = isMobile ? 60 : isTablet ? 70 : 100;
//   const associationRepeatCount = 12;
//   const associationTotalImages = 5 * associationRepeatCount; // 5 logos per set
//   const associationScrollAmount = associationLogoHeight * associationTotalImages;

//   const partnerLogos = [
//     "Google_Cloud_Partner_no_outline_vertical_1.webp",
//     "/nasscom.svg"
//   ];
  
//   const associationLogos = [
//     "/ATPT_Logo1.png",
//     "/cloudexperts.png",
//     "/Modigie.png",
//     "/FGIcons_Logo.png",
//     "/cwx.png"
//   ];

//   // Function to get logo height based on the logo source
//   const getLogoHeight = (logoSrc) => {
//     if (logoSrc === "/cwx.png") {
//       // Increase CloudWerx logo height by 50%
//       return {
//         xs: "40px", // 150px * 1.5
//         sm: "50px", // 200px * 1.5
//         md: "90px"   // 60px * 1.5
//       };
//     }
  
//     if (logoSrc === "/ATPT_Logo1.png") {
//       // Custom height for ATPT logo
//       return {
//         xs: "55px",
//         sm: "55px",
//         md: "90px"
//       };
//     }
//     if (logoSrc === "/cloudexperts.png") {
//       // Custom height for ATPT logo
//       return {
//         xs: "55px",
//         sm: "55px",
//         md: " 90px"
//       };
//     }
  
//     // Default height for other logos
//     return {
//       xs: "40px",
//       sm: "50px",
//       md: "60px"
//     };
//   };

//   return (
//     <>
//       {/* Strategic Alliances Section */}
//       <Box
//         sx={{
//           padding: "90px",
//           width: "100%",
//           height: "auto",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           textAlign: "center",
//           paddingX: isMobile ? "20px" : "100px",
//         }}
//       >
//         <Grid
//           container
//           spacing={3}
//           sx={{
//             alignContent: "center",
//             justifyContent: "center",
//             maxWidth: "1200px",
//             marginX: "auto",
//           }}
//         >
//           {/* Text Section */}
//           <Grid item xs={12}>
//             <Typography
//               sx={{
//                 fontSize: isMobile ? "35px" : isTablet ? "40px" : "42px",
//                 textTransform: "capitalize",
//                 fontWeight: 400,
//                 marginBottom: "30px",
//               }}
//             >
//               Our Strategic Alliances & Industry Footprint
//             </Typography>
//           </Grid>
          
//           {/* Logo Carousel Section */}
//           <Grid
//             item
//             xs={12}
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               mt: 3,
//             }}
//           >
//             <Box
//               sx={{
//                 background: "white",
//                 height: allianceLogoHeight,
//                 margin: "auto",
//                 overflow: "hidden",
//                 position: "relative",
//                 width: { xs: "100%", sm: "80%", md: "600px" },
//                 "&:before, &:after": {
//                   content: '""',
//                   height: allianceLogoHeight,
//                   position: "absolute",
//                   width: { xs: "50px", sm: "100px", md: "150px" },
//                   zIndex: 2,
//                   background: "linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 50%)",
//                 },
//                 "&:after": {
//                   right: 0,
//                   top: 0,
//                   transform: "rotateZ(180deg)",
//                 },
//                 "&:before": {
//                   left: 0,
//                   top: 0,
//                 },
//               }}
//             >
//               <Box
//                 sx={{
//                   animation: "scroll 45s linear infinite",
//                   display: "flex",
//                   width: `calc(${allianceLogoHeight}px * ${allianceTotalImages})`,
//                   "@keyframes scroll": {
//                     "0%": { transform: "translateX(0)" },
//                     "100%": { transform: `translateX(-${allianceScrollAmount}px)` },
//                   },
//                 }}
//               >
//                 {/* Repeat logos for seamless infinite scroll */}
//                 {[...Array(allianceRepeatCount)].map((_, index) => (
//                   <React.Fragment key={index}>
//                     <Box
//                       component="img"
//                       src="Google_Cloud_Partner_no_outline_vertical_1.webp"
//                       alt="Google Cloud Partner logo - Empowering innovation with Google Cloud solutions"
//                       sx={{
//                         height: { xs: "150px", sm: "200px", md: "300px" },
//                         width: "auto",
//                         px: { xs: "37px", sm: "50px", md: "75px" },
//                       }}
//                     />
//                     <Box
//                       component="img"
//                       src="/nasscom.svg"
//                       alt="Nasscom logo"
//                       sx={{
//                         height: { xs: "150px", sm: "200px", md: "300px" },
//                         width: { xs: "150px", sm: "200px", md: "300px" },
//                       }}
//                     />
//                   </React.Fragment>
//                 ))}
//               </Box>
//             </Box>
//           </Grid>
//           {/* Explore More Button */}
//           <Button
//               component={Link}
//               to="/alliance"
//               variant="outlined"
//               sx={{
//                 borderRadius: "50px",
//                 border: "2px solid #0087B4",
//                 color: "#0087B4",
//                 padding: "10px 20px",
//                 textTransform: "none",
//                 fontSize: "18px",
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 marginTop: "20px",
//                 transition: "background-color 0.3s ease-in-out, color 0.3s ease-in-out",
//                 "&:hover": {
//                   backgroundColor: "#0087B4",
//                   color: "#FFFFFFD9",
//                 },
//                 "&:hover .MuiSvgIcon-root": {
//                   transform: "translateX(-5px)",
//                   opacity: 1,
//                   transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
//                 },
//                 "&:hover .text": {
//                   transform: "translateX(3px)",
//                   transition: "transform 0.3s ease-in-out",
//                 },
//               }}
//             >
//               <Typography
//                 className="text"
//                 sx={{
//                   transition: "transform 0.3s ease-in-out",
//                   fontWeight: 380,
//                   fontSize: "18px",
//                 }}
//               >
//                 Explore more
//               </Typography>
//               <ArrowForward
//                 sx={{
//                   opacity: 0.6,
//                   transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
//                 }}
//               />
//             </Button>
//         </Grid>
//       </Box>

//       {/* Associations Section */}
//       <Box
//   sx={{
//     pt: "0px",
//     pb:"90px",
//     width: "100%",
//     height: "auto",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//     paddingX: isMobile ? "20px" : "100px",
//   }}
// >
//   <Grid
//     container
//     spacing={3}
//     sx={{
//       alignContent: "center",
//       justifyContent: "center",
//       maxWidth: "1200px",
//       marginX: "auto",
//     }}
//   >
//     {/* Text Section */}
//     <Grid item xs={12}>
//       <Typography
//         sx={{
//           fontSize: isMobile ? "35px" : isTablet ? "40px" : "42px",
//           textTransform: "capitalize",
//           fontWeight: 400,
//           marginBottom: "30px",
//         }}
//       >
//         Our Associations
//       </Typography>
//     </Grid>
    
//     {/* Logo Carousel Section */}
//     <Grid
//       item
//       xs={12}
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         mt: 3,
//       }}
//     >
//       <Box
//         sx={{
//           background: "white",
//           height: associationLogoHeight,
//           overflow: "hidden",
//           position: "relative",
//           width: { xs: "200%", sm: "200%", md: "200%" },
//         }}
//         onMouseEnter={(e) => {
//           const animatedBox = e.currentTarget.querySelector('[data-animated="true"]');
//           if (animatedBox) {
//             animatedBox.style.animationPlayState = 'paused';
//           }
//         }}
//         onMouseLeave={(e) => {
//           const animatedBox = e.currentTarget.querySelector('[data-animated="true"]');
//           if (animatedBox) {
//             animatedBox.style.animationPlayState = 'running';
//           }
//         }}
//       >
//         <Box
//           data-animated="true"
//           sx={{
//             animation: "scroll2 45s linear infinite",
//             display: "flex",
//             width: `calc(${associationLogoHeight}px * ${associationTotalImages})`,
//             "@keyframes scroll2": {
//               "0%": { transform: "translateX(0)" },
//               "100%": { transform: `translateX(-${associationScrollAmount}px)` },
//             },
//           }}
//         >
//           {[...Array(associationRepeatCount)].map((_, index) => (
//             <React.Fragment key={index}>
//               {associationLogos.map((logoSrc, logoIndex) => (
//                 <Box
//                   key={`logo-${index}-${logoIndex}`}
//                   component="img"
//                   src={logoSrc}
//                   alt={`Partner logo ${logoIndex + 1}`}
//                   sx={{
//                     height: getLogoHeight(logoSrc),
//                     width: "auto",
//                     px: { xs: "37px", sm: "50px", md: "75px" },
//                     // Method 1: Enhanced grayscale with brightness/contrast adjustment
//                     filter: "grayscale(100%)",
//                   // filter: "brightness(70%) saturate(100%) invert(75%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)",
//             opacity: 1,
//                     transition: "all 0.3s ease",
//                     // "&:hover": {
//                     //   filter: "grayscale(0%) brightness(1) contrast(1)",
//                     //   opacity: 1,
//                     // },
//                   }}
//                 />
//               ))}
//             </React.Fragment>
//           ))}
//         </Box>
//       </Box>
//     </Grid>
//   </Grid>
// </Box>
//     </>
//   );
// };

// export default Partner;

import React from 'react';
import { Box, Grid, Typography, Button,useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';
import { ArrowForward } from '@mui/icons-material';
import { useTheme } from "@mui/material/styles";

const Partner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  // Strategic Alliances configuration
  const allianceLogoHeight = isMobile ? 150 : isTablet ? 200 : 300;
  const allianceRepeatCount = 12;
  const allianceTotalImages = 2 * allianceRepeatCount;
  const allianceScrollAmount = allianceLogoHeight * allianceTotalImages;

  // Associations configuration  
  const associationLogoHeight = isMobile ? 60 : isTablet ? 70 : 115;
  const associationRepeatCount = 12;
  const associationTotalImages = 5 * associationRepeatCount; // 5 logos per set
  const associationScrollAmount = associationLogoHeight * associationTotalImages;

  const partnerLogos = [
    "Google_Cloud_Partner_no_outline_vertical_1.webp",
    "/nasscom.svg"
  ];
  
  const associationLogos = [
    "/ATPT_Logo1.png",
    "/cloudexperts.png",
    "/Modigie.png",
    "/FGIcons_Logo.png",
    "/cwx.png"
  ];

  // Function to get logo height based on the logo source
  const getLogoHeight = (logoSrc) => {
    if (logoSrc === "/cwx.svg") {
      // Increase CloudWerx logo height by 50%
      return {
        xs: "40px", // 150px * 1.5
        sm: "50px", // 200px * 1.5
        md: "97px"   // 60px * 1.5
      };
    }
  
    // if (logoSrc === "/ATPT_Logo1.png") {
    //   // Custom height for ATPT logo
    //   return {
    //     xs: "55px",
    //     sm: "55px",
    //     md: "100px"
    //   };
    // }
  
    // Default height for other logos
    return {
      xs: "40px",
      sm: "50px",
      md: "60px"
    };
  };

  return (
    <>
      {/* Strategic Alliances Section */}
      <Box
        sx={{
          padding: "90px",
          width: "100%",
          height: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          paddingX: isMobile ? "20px" : "100px",
        }}
      >
        <Grid
          container
          spacing={3}
          sx={{
            alignContent: "center",
            justifyContent: "center",
            maxWidth: "1200px",
            marginX: "auto",
          }}
        >
          {/* Text Section */}
          <Grid item xs={12}>
            <Typography
              sx={{
                fontSize: isMobile ? "35px" : isTablet ? "40px" : "42px",
                textTransform: "capitalize",
                fontWeight: 400,
                marginBottom: "30px",
              }}
            >
              Our Strategic Alliances & Industry Footprint
            </Typography>
          </Grid>
          
          {/* Logo Carousel Section */}
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 3,
            }}
          >
            <Box
              sx={{
                background: "white",
                height: allianceLogoHeight,
                margin: "auto",
                overflow: "hidden",
                position: "relative",
                width: { xs: "100%", sm: "80%", md: "600px" },
                "&:before, &:after": {
                  content: '""',
                  height: allianceLogoHeight,
                  position: "absolute",
                  width: { xs: "50px", sm: "100px", md: "150px" },
                  zIndex: 2,
                  background: "linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 50%)",
                },
                "&:after": {
                  right: 0,
                  top: 0,
                  transform: "rotateZ(180deg)",
                },
                "&:before": {
                  left: 0,
                  top: 0,
                },
              }}
            >
              <Box
                sx={{
                  animation: "scroll 65s linear infinite",
                  display: "flex",
                  width: `calc(${allianceLogoHeight}px * ${allianceTotalImages})`,
                  "@keyframes scroll": {
                    "0%": { transform: "translateX(0)" },
                    "100%": { transform: `translateX(-${allianceScrollAmount}px)` },
                  },
                }}
              >
                {/* Repeat logos for seamless infinite scroll */}
                {[...Array(allianceRepeatCount)].map((_, index) => (
                  <React.Fragment key={index}>
                    <Box
                      component="img"
                      src="Google_Cloud_Partner_no_outline_vertical_1.webp"
                      alt="Google Cloud Partner logo - Empowering innovation with Google Cloud solutions"
                      sx={{
                        height: { xs: "150px", sm: "200px", md: "300px" },
                        width: "auto",
                        px: { xs: "37px", sm: "50px", md: "75px" },
                      }}
                    />
                    <Box
                      component="img"
                      src="/nasscom.svg"
                      alt="Nasscom logo"
                      sx={{
                        height: { xs: "150px", sm: "200px", md: "300px" },
                        width: { xs: "150px", sm: "200px", md: "300px" },
                      }}
                    />
                  </React.Fragment>
                ))}
              </Box>
            </Box>
          </Grid>
          {/* Explore More Button */}
          <Button
              component={Link}
              to="/alliance"
              variant="outlined"
              sx={{
                borderRadius: "50px",
                border: "2px solid #0087B4",
                color: "#0087B4",
                padding: "10px 20px",
                textTransform: "none",
                fontSize: "18px",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                marginTop: "20px",
                transition: "background-color 0.3s ease-in-out, color 0.3s ease-in-out",
                "&:hover": {
                  backgroundColor: "#0087B4",
                  color: "#FFFFFFD9",
                },
                "&:hover .MuiSvgIcon-root": {
                  transform: "translateX(-5px)",
                  opacity: 1,
                  transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
                },
                "&:hover .text": {
                  transform: "translateX(3px)",
                  transition: "transform 0.3s ease-in-out",
                },
              }}
            >
              <Typography
                className="text"
                sx={{
                  transition: "transform 0.3s ease-in-out",
                  fontWeight: 380,
                  fontSize: "18px",
                }}
              >
                Explore more
              </Typography>
              <ArrowForward
                sx={{
                  opacity: 0.6,
                  transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
                }}
              />
            </Button>
        </Grid>
      </Box>

      {/* Associations Section */}
      <Box
  sx={{
    pt: "0px",
    pb:"90px",
    width: "100%",
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    paddingX: isMobile ? "20px" : "100px",
    // bgcolor: "#F2F3F5",
  }}
>
  <Grid
    container
    spacing={3}
    sx={{
      alignContent: "center",
      justifyContent: "center",
      maxWidth: "1200px",
      marginX: "auto",
    }}
  >
    {/* Text Section */}
    <Grid item xs={12}>
      <Typography
        sx={{
          fontSize: isMobile ? "35px" : isTablet ? "40px" : "42px",
          textTransform: "capitalize",
          fontWeight: 400,
          marginBottom: "30px",
        }}
      >
        Trusted By
      </Typography>
    </Grid>
    
    {/* Logo Carousel Section */}
    <Grid
      item
      xs={12}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 3,
      }}
    >
      <Box
        sx={{
          height: associationLogoHeight,
          overflow: "hidden",
          position: "relative",
          width: { xs: "200%", sm: "200%", md: "200%" },
        }}
        onMouseEnter={(e) => {
          const animatedBox = e.currentTarget.querySelector('[data-animated="true"]');
          if (animatedBox) {
            animatedBox.style.animationPlayState = 'paused';
          }
        }}
        onMouseLeave={(e) => {
          const animatedBox = e.currentTarget.querySelector('[data-animated="true"]');
          if (animatedBox) {
            animatedBox.style.animationPlayState = 'running';
          }
        }}
      >
        <Box
          data-animated="true"
          sx={{
            animation: "scroll2 50s linear infinite",
            display: "flex",
            alignItems: "center",
            width: `calc(${associationLogoHeight}px * ${associationTotalImages})`,
            "@keyframes scroll2": {
              "0%": { transform: "translateX(0)" },
              "100%": { transform: `translateX(-${associationScrollAmount}px)` },
            },
          }}
        >
          {[...Array(associationRepeatCount)].map((_, index) => (
            <React.Fragment key={index}>
              {associationLogos.map((logoSrc, logoIndex) => (
                <Box
                  key={`logo-${index}-${logoIndex}`}
                  sx={{
                    px: { xs: "20px", sm: "25px", md: "35px" }, // Spacing between logo containers
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      bgcolor: "white",
                      borderRadius: "8px", // Optional: adds rounded corners
                      padding: { xs: "15px 20px", sm: "20px 25px", md: "25px 30px" }, // Padding around each logo
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      // boxShadow: "0 2px 8px rgba(0,0,0,0.1)", // Optional: subtle shadow
                      border: "1px solid #BBBBBB",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        // transform: "translateY(-2px)", // Optional: slight lift on hover
                        // boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      },
                      width:"200px"
                    }}
                  >
                    <Box
                      component="img"
                      src={logoSrc}
                      alt={`Partner logo ${logoIndex + 1}`}
                      sx={{
                        height: getLogoHeight(logoSrc),
                        width: "auto",
                        maxWidth: "120px", // Optional: limit max width
                        objectFit: "contain",
                        transition: "all 0.3s ease",
                      }}
                    />
                  </Box>
                </Box>
              ))}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Grid>
  </Grid>
</Box>
    </>
  );
};

export default Partner;